"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"

export default function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: "What should I bring to my first session?",
      answer:
        "Just bring comfortable athletic wear, indoor shoes, and a water bottle. We provide all the dodgeballs and equipment you'll need!",
    },
    {
      question: "Do I need experience to join?",
      answer:
        "Not at all! We welcome players of all skill levels, from complete beginners to experienced players. Our coaches will help you learn the basics.",
    },
    {
      question: "How do I book a session?",
      answer:
        "You can book sessions through our website, WhatsApp, or Discord. Drop-in players can also just show up, but we recommend booking to guarantee your spot.",
    },
    {
      question: "What's the age range for youth programs?",
      answer:
        "Our youth programs are designed for ages 8-17. We have different groups based on age and skill level to ensure everyone has fun and stays safe.",
    },
    {
      question: "Can I get a refund if I can't attend?",
      answer:
        "Yes! You can cancel up to 24 hours before a session for a full refund. Monthly memberships can be paused if you're going away.",
    },
  ]

  return (
    <div className="max-w-3xl mx-auto">
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden reveal">
            <button
              className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span className="font-semibold text-lg text-black">{faq.question}</span>
              <ChevronDown
                className={`h-5 w-5 text-[#E67E22] transition-transform ${openIndex === index ? "rotate-180" : ""}`}
              />
            </button>
            {openIndex === index && (
              <div className="px-8 pb-6">
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
